import moment from "moment";
import { IShipmentsPerDay } from "../../../api/ShipmentsPerDay/ShipmentsPerDay.types";
import WidgetNivoBase from "../Widget.nivo.base";
import Tooltips from "../../common/Tooltips/Tooltips";
import "./styles.scss";

interface Props {
  data?: IShipmentsPerDay[]
}

function ShipmentsPerDay({ data }: Props) {
  const x_cpd_map: Record<string, string> = {};

  function getData() {
    if (data) {
      const newData = [
        {
          id: "Shipments Per Day",
          data: data.map(d => {
            const x = `${moment(d.departureDate).format("MM/DD/YYYY")}`;

            // mapping the shipmentCount per day
            x_cpd_map[x] = d.containerCount;

            return {
              x,
              y: d.shipmentCount
            }
          })
        }
      ];

      return newData;
    }
  }

  return (
    <div className="shipments-per-day">
      <WidgetNivoBase.Line
        title={
          <Tooltips
            label={
              <>
                <span>Dates are in Actual Departure Date</span>
              </>
            }
            children="Shipments Per Day"
          />
        }
        data={getData()}
        marginBottom={5}
        curve="monotoneX"
        colors={{scheme: "category10"}}
        axisLeftName="Container Count"
        axisBottom={null}
        enableGridX={false}
        sliceTooltip={({ slice }) => (
          <div
            style={{
              fontSize: 12,
              background: 'white',
              padding: '9px 12px',
              border: '1px solid #ccc',
            }}
          >
            {slice.points.map((point: any) => (
              <div
                key={point.id}
              >
                <div>Date: <strong>{point.data.xFormatted}</strong></div>
                <div>{point.serieId}: <strong>{point.data.yFormatted}</strong></div>
                <div>Containers Per Day: <strong>{x_cpd_map[point.data.xFormatted]}</strong></div>
              </div>
            ))}
          </div>
        )}
      />
    </div>
  )
}

export default ShipmentsPerDay;
